import $ from 'jquery'
import ListesPaginees from '@/api/parametres/_listes-paginees'

export default {
    name: 'manage-admission',
    components: {},
    props: {
        admission_to_fill: Object,
        type_admission_to_delete: Object,
        adm_modal_title: String,
        type_admission: String,
        is_edit: Number,
        unites_soins: { type: Array, default: () => [] }
    },
    data() {
        return {
            save_loading: false,
            chambre_is_empty: false,
            observation_is_empty: false,
            must_create_room: false,
            must_create_observation: false,

            is_exist: false,
            is_error: false,

            del_loading: false,
            is_confirm: false,

            msg_error: ""
        }
    },

    watch: {
        admission_to_fill() {
            this.getListeChambre()
            this.getListeObservation()
            this.clearError()
            this.$refs.adm_form.reset()
        },

        type_admission_to_delete() {
            this.is_confirm = false
        }
    },

    computed: {
        userCredentials() {
            return this.$store.getters['authInfo'];
        },

        liste_type_mix_datas() {
            return this.$store.getters["liste_type_mix_datas"];
        },

        // Unités actives, plus l'unité actuelle de la chambre même si elle a été désactivée.
        unitesProposees() {
            const actuelle = Number(this.admission_to_fill && this.admission_to_fill.hospital_service_id)
            return this.unites_soins.filter(unite => unite.is_active || Number(unite.id) === actuelle)
        },
    },

    mounted() {
        // Liste facturation acte
        this.getListeFacturatonActe()

        // this.getListeChambre()
        // this.getListeObservation()
    },

    methods: {
        getListeFacturatonActe() {
            this.$store.dispatch("getListeTypeMixData", 'facturation_acte')
        },

        /**
         * Existe-t-il au moins une chambre ? (contrôle « Avec chambre » à l'enregistrement d'une admission)
         * Seul le total est utile : une page d'une ligne suffit, inutile de charger toute la liste (15/10/2026)
         */
        getListeChambre() {
            return ListesPaginees.typesAdmission('chambre', { page: 1, per_page: 1 }).then((reponse) => {
                this.chambre_is_empty = !(reponse && reponse.total > 0)
            }).catch(() => {})
        },

        /**
         * Existe-t-il au moins une observation ? (contrôle « Avec observation » à l'enregistrement d'une admission)
         */
        getListeObservation() {
            return ListesPaginees.typesAdmission('observation', { page: 1, per_page: 1 }).then((reponse) => {
                this.observation_is_empty = !(reponse && reponse.total > 0)
            }).catch(() => {})
        },

        /**
         * Efface le prix défini pour le prix d'une admission au changement
         */
        handleFacturationAdmission(type) {
            if (type == 'admission') {
                this.admission_to_fill.prix = ""
                this.admission_to_fill.prix_journalier = ""
                this.admission_to_fill.facturation_acte = null
            } else if (type == 'observation') {
                this.admission_to_fill.facturation_acte = null
                this.admission_to_fill.prix_journalier = ""
            } else {
                this.admission_to_fill.prix_journalier = ""
            }  
        },

        handleActionTypeChambre() {
            this.admission_to_fill.lits = [
                {
                    libelle: ''
                }
            ]
        },

        addLit() {
            this.msg_error = ""
            let one_is_empty = false
            this.admission_to_fill.lits.forEach(lit => {
                if (lit.libelle === '' || lit === '') {
                    one_is_empty = true
                }
            });
            if (one_is_empty) {
                this.msg_error = "Vous devez renseigner le nom du lit avant d'ajouter un autre lit."
                return;
            }

            this.admission_to_fill.lits.push({
                libelle: ''
            })
        },

        async submit() {
            let isValid = null
            if (this.type_admission == 'admission') {
                isValid = await this.$refs.adm_form.validate();
            } else {
                isValid = await this.$refs.autre_adm_form.validate();
            }

            if (!isValid) {
                return;
            }

            if (this.type_admission == 'admission') {
                // Check if at least one "Chambre" is created
                if (this.admission_to_fill.is_with_room == 1 && this.chambre_is_empty) {
                    this.must_create_room = true
                    return;
                }

                // Check if at least one "Observation" is created
                if (this.admission_to_fill.is_with_observation == 1 && this.observation_is_empty) {
                    this.must_create_observation = true
                    return;
                }
            }

            this.save_loading = true 
            this.$store.dispatch('storeAdmission', this.admission_to_fill).then((response) => {
                if (response.success) {
                    if (this.type_admission == 'admission') {
                        this.successToast("Admission ajoutée avec succès")

                        this.$refs.adm_form.reset()
                        this.$emit('emitAdmission')
                        this.$refs.modal_admission.click()
                    } else if (this.type_admission == 'chambre') {
                        this.successToast("Chambre ajoutée avec succès")

                        this.$refs.autre_adm_form.reset()
                        this.$emit('emitChambre')
                        this.$refs.modal_autre_admission.click()
                    } else if (this.type_admission == 'observation') {
                        this.successToast("Observation ajoutée avec succès")

                        this.$refs.autre_adm_form.reset()
                        this.$emit('emitObservation')
                        this.$refs.modal_autre_admission.click()
                    }
                    
                } else {
                    this.msg_error = response.message
                }
                this.save_loading = false
            }).catch(() => {
                this.save_loading = false
                this.msg_error = "Une erreur est survenue. Veuillez réessayer plus tard."
            })

        },

        clearError() {
            this.must_create_room = false
            this.must_create_observation = false
            this.is_exist = false
            this.is_error = false
            this.msg_error = ""
        },

         /**
         * Cache le message d'erreur au click du checkbox
         */
         onConfirm() {
            $('.err-msg').fadeOut(500);
        },

        confirmer() {
            this.is_confirm = true
        },

        supprimer(selector) {
            this.del_loading = true;

            let confirm = document.getElementById(selector);
            
            if (confirm.checked == false) { //  Vérifie si l'utilisateur a confirmé la cloture
                $('.err-msg').fadeIn(500)
                this.del_loading = false
                return
            }

            this.$store.dispatch('deleteAdmissionByType', this.type_admission_to_delete).then((response) => {
                if (response > 0) {
                    this.successToast("Suppression effectuée avec succès")

                    if (this.type_admission_to_delete.type_del == 'admission') {
                        this.$emit('emitAdmission')
                    } else if (this.type_admission_to_delete.type_del == 'chambre') {
                        this.$emit('emitChambre')
                    } else if (this.type_admission_to_delete.type_del == 'observation') {
                        this.$emit('emitObservation')
                    }

                    this.is_confirm = false
                    this.$refs.del_admission.click();
                }
                this.del_loading = false
            }).catch(() => {
                this.del_loading = false
            })
        },
    }
}


